{
  "common.close": "ಮುಚ್ಚಿ",
  "common.athleteFallback": "ಕ್ರೀಡಾಪಟು {id}",
  "splash.title": "{app} — ಚಟುವಟಿಕೆಗಳ ಅನಿಮೇಟೆಡ್ ದೃಶ್ಯ",
  "splash.tagline": "ನಿಮ್ಮ&nbsp;Strava ಡೇಟಾಗೆ ಚಲಿಸುವ ನಕ್ಷೆ",
  "splash.demo": "ಡೆಮೊ",
  "tab.query.title": "{name} ಅವರ ನಕ್ಷೆ",
  "tab.query.heading": "ಚಟುವಟಿಕೆಗಳನ್ನು ಹುಡುಕಿ:",
  "tab.query.optDays": "ಇತ್ತೀಚಿನ ದಿನಗಳು",
  "tab.query.optActivities": "ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆಗಳು",
  "tab.query.optIds": "ಚಟುವಟಿಕೆ IDಗಳು",
  "tab.query.optDates": "ದಿನಾಂಕ ವ್ಯಾಪ್ತಿ",
  "tab.query.idsPlaceholder": "ಚಟುವಟಿಕೆ IDಗಳನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ",
  "tab.query.after": "ನಂತರ:",
  "tab.query.before": "ಮೊದಲು:",
  "tab.query.autozoom": "ಆಮದಿನ ನಂತರ ಫಲಿತಾಂಶಕ್ಕೆ ಸ್ವಯಂ ಜೂಮ್ <i class=\"hf hf-bullseye\"></i>",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> ಹುಡುಕಿ",
  "tab.query.createAccount": "ಖಾತೆ ರಚಿಸಿ ಮತ್ತು/ಅಥವಾ ಲಾಗಿನ್ ಆಗಿ.",
  "tab.query.sports": "ಕ್ರೀಡೆಗಳು:",
  "tab.query.allSports": "ಎಲ್ಲಾ ಕ್ರೀಡೆಗಳು",
  "tab.query.sportsExcept": "ಇವುಗಳನ್ನು ಬಿಟ್ಟು ಎಲ್ಲಾ",
  "tab.query.sportsNone": "ಯಾವುದೂ ಇಲ್ಲ",
  "tab.query.loadingSports": "ಕ್ರೀಡೆಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ…",
  "tab.query.sportsFailed": "ಈ ನಕ್ಷೆಯ ಕ್ರೀಡೆಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ",
  "tab.query.noSports": "ಇನ್ನೂ ಯಾವುದೇ ಚಟುವಟಿಕೆಗಳಿಲ್ಲ",
  "tab.activities.title": "ತೋರಿಸಿದ ಚಟುವಟಿಕೆಗಳು",
  "tab.activities.clearSelection": "ಆಯ್ಕೆ ತೆರವುಗೊಳಿಸಿ",
  "tab.activities.renderSelected": "ಆಯ್ದವನ್ನು ತೋರಿಸಿ",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> ಆಯ್ಕೆಗೆ ಜೂಮ್ ಮಾಡಿ",
  "tab.controls.title": "ಲೇಯರ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
  "tab.controls.timescale": "ಕಾಲಮಾನ <i>&tau;</i>",
  "tab.controls.timescaleHint": "ಪ್ಲೇಬ್ಯಾಕ್ ವೇಗ",
  "tab.controls.period": "ಆವರ್ತನ <i>T</i>",
  "tab.controls.periodHint": "ಚಟುವಟಿಕೆ ~ ಮಾದರಿ",
  "tab.controls.dotSize": "ಚುಕ್ಕೆ ಗಾತ್ರ",
  "tab.controls.pathWidth": "ಹಾದಿ ಅಗಲ",
  "tab.controls.pathWidthHint": "ಸೊನ್ನೆ ಹಾದಿಗಳನ್ನು ಮರೆಮಾಡುತ್ತದೆ",
  "tab.controls.colors": "ಬಣ್ಣಗಳು",
  "tab.controls.colorsHint": "ಬಣ್ಣದ ಪ್ಯಾಲೆಟ್ ತಿರುಗಿಸಿ",
  "tab.controls.shadows": "ನೆರಳುಗಳು",
  "tab.profile.loginTitle": "ಲಾಗಿನ್",
  "tab.profile.anonNote": "ನಿಮ್ಮ ಸ್ವಂತ ಚಟುವಟಿಕೆಗಳನ್ನು ನೋಡಲು ಮತ್ತು ನಿಮ್ಮ Heatflask ಖಾತೆಯನ್ನು ನಿರ್ವಹಿಸಲು Strava ಮೂಲಕ ಲಾಗಿನ್ ಆಗಿ.",
  "tab.profile.loginLink": "Strava ಮೂಲಕ ಲಾಗಿನ್ ಆಗಿ",
  "tab.profile.editOnStrava": "Strava ನಲ್ಲಿ ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
  "tab.profile.indexNote": "ವೇಗವಾಗಿ ಸಿಗಲೆಂದು ನಿಮ್ಮ ಚಟುವಟಿಕೆಗಳ ಸಾರಾಂಶಗಳನ್ನು ನಾವು ಸೂಚಿಯಲ್ಲಿ ಇಡುತ್ತೇವೆ.",
  "tab.profile.viewIndex": "ಸೂಚಿ ನೋಡಿ",
  "tab.profile.sharedMaps": "ಹಂಚಿದ ನಕ್ಷೆಗಳು",
  "tab.profile.sharedMapsNote": "ಆಫ್: Heatflask ನಲ್ಲಿ ನಿಮ್ಮ ಚಟುವಟಿಕೆಗಳನ್ನು ನೀವು ಮಾತ್ರ ನೋಡಬಹುದು. ಆನ್: ನಿಮ್ಮ ನಕ್ಷೆಯ ಲಿಂಕ್ ಇರುವ ಯಾರಾದರೂ ನೀವು Strava ನಲ್ಲಿ ಸಾರ್ವಜನಿಕಗೊಳಿಸಿದ ಚಟುವಟಿಕೆಗಳನ್ನು ನೋಡಬಹುದು. ನಿಮ್ಮ ಖಾಸಗಿ ಚಟುವಟಿಕೆಗಳು ಹೇಗಿದ್ದರೂ ನಿಮ್ಮವೇ ಆಗಿರುತ್ತವೆ. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">ಗೌಪ್ಯತೆ ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ</a>",
  "tab.profile.logout": "ಲಾಗ್ ಔಟ್",
  "tab.profile.deleteAccount": "ಖಾತೆ ಅಳಿಸಿ",
  "tab.profile.deleteConfirm": "ನಿಮ್ಮ Heatflask ಖಾತೆಯನ್ನು ಅಳಿಸಬೇಕೇ?\n\nಇದು ನಿಮ್ಮ ಸೂಚಿಯಲ್ಲಿರುವ ಚಟುವಟಿಕೆಗಳನ್ನು ತೆಗೆದುಹಾಕುತ್ತದೆ ಮತ್ತು ನಿಮ್ಮ Strava ಡೇಟಾಗೆ Heatflask ನ ಪ್ರವೇಶವನ್ನು ರದ್ದುಗೊಳಿಸುತ್ತದೆ. ಇದನ್ನು ಹಿಂತಿರುಗಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ.",
  "tab.profile.languageHeading": "ಭಾಷೆ",
  "tab.profile.languageAuto": "ಸ್ವಯಂಚಾಲಿತ",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">ಅನುವಾದಗಳನ್ನು ಸರಿಪಡಿಸಲು ಅಥವಾ ಹೊಸದನ್ನು ಸೇರಿಸಲು ನಮಗೆ ಸಹಾಯ ಮಾಡಿ!</a>",
  "tab.profile.unitsHeading": "ಮಾನಗಳು",
  "tab.profile.unitsAuto": "ಸ್ವಯಂಚಾಲಿತ",
  "tab.profile.unitsMetric": "ಮೆಟ್ರಿಕ್ (ಕಿ.ಮೀ, ಮೀ)",
  "tab.profile.unitsImperial": "ಇಂಪೀರಿಯಲ್ (ಮೈಲಿ, ಅಡಿ)",
  "tab.profile.textSizeHeading": "ಅಕ್ಷರ ಗಾತ್ರ",
  "tab.profile.textSmaller": "ಚಿಕ್ಕದು",
  "tab.profile.textReset": "ಸಾಮಾನ್ಯ",
  "tab.profile.textLarger": "ದೊಡ್ಡದು",
  "tab.profile.mapDefaultsHeading": "ನಕ್ಷೆ ಡೀಫಾಲ್ಟ್‌ಗಳು",
  "tab.profile.mapDefaultsNote": "ಲಿಂಕ್ ತನ್ನದೇ ಸೆಟ್ಟಿಂಗ್ ಹೊಂದಿರದ ನಕ್ಷೆಯನ್ನು ತೆರೆದಾಗಲೆಲ್ಲ ಈ ಬೇಸ್‌ಮ್ಯಾಪ್, ಭೂಪ್ರದೇಶ ಮತ್ತು ಲೇಯರ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳಿಂದ ಪ್ರಾರಂಭಿಸಿ. ನೀವು ಹಂಚುವ ಲಿಂಕ್‌ಗಳು ಆದರೂ ನೀವು ನೋಡುವುದನ್ನೇ ನಿಖರವಾಗಿ ತೋರಿಸುತ್ತವೆ.",
  "tab.profile.mapDefaultsSave": "ನನ್ನ ಡೀಫಾಲ್ಟ್ ಆಗಿ ಉಳಿಸಿ",
  "tab.profile.mapDefaultsForget": "ಮರೆತುಬಿಡಿ",
  "tab.info.title": "ಮಾಹಿತಿ",
  "tab.info.controlsHeading": "ನಿಯಂತ್ರಣಗಳು",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + ಎಳೆಯಿರಿ",
  "tab.info.shiftDragDesc": "ಒಂದು ಪೆಟ್ಟಿಗೆಯೊಳಗೆ ಚಟುವಟಿಕೆಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ. ಟಚ್‌ಸ್ಕ್ರೀನ್‌ನಲ್ಲಿ ಮೊದಲು <i class=\"hf-object-group\"></i> ಒತ್ತಿ, ನಂತರ ಒಂದು ಬೆರಳಿನಿಂದ ಎಳೆಯಿರಿ. ಕೊನೆಯದಾಗಿ ಆಯ್ದ ಚಟುವಟಿಕೆಯ ವಿವರಗಳು ಕಾಣುತ್ತವೆ, ಮತ್ತು ಚಟುವಟಿಕೆ ಪಟ್ಟಿ ಅದರವರೆಗೆ ಸ್ಕ್ರೋಲ್ ಆಗುತ್ತದೆ.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + ಎಳೆಯಿರಿ",
  "tab.info.ctrlDragDesc": "ನಕ್ಷೆಯನ್ನು 3D ಯಲ್ಲಿ ತಿರುಗಿಸಿ ಮತ್ತು ಓರೆ ಮಾಡಿ, ಅಥವಾ ಎರಡು ಬೆರಳುಗಳನ್ನು ಬಳಸಿ",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "ಸೈಡ್‌ಬಾರ್ ತೆರೆಯಿರಿ ಅಥವಾ ಮುಚ್ಚಿ",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "ಹಿಂದಿನ ಅಥವಾ ಮುಂದಿನ ಸೈಡ್‌ಬಾರ್ ಟ್ಯಾಬ್",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "ಸೈಡ್‌ಬಾರ್ ಮುಚ್ಚಿ",
  "tab.info.liveUrlHeading": "ಲೈವ್ URL",
  "tab.info.liveUrlDesc": "ನಕ್ಷೆಯ ನೋಟ ಮತ್ತು ಅನಿಮೇಷನ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳು ಪುಟದ URL ನಲ್ಲಿ ಇರುತ್ತವೆ, ಆದ್ದರಿಂದ ನೀವು ಯಾರಿಗೆ ಹಂಚಿದರೂ ಅವರು ಅದೇ ನೋಟವನ್ನು ನೋಡುತ್ತಾರೆ.",
  "tab.info.videoHeading": "ವೀಡಿಯೊ ರಫ್ತು",
  "tab.info.videoDesc": "<i class=\"hf-video-camera\"></i> ಬಟನ್ ಅನಿಮೇಷನ್ ಅನ್ನು MP4 ಆಗಿ ರೆಕಾರ್ಡ್ ಮಾಡುತ್ತದೆ: ಅದನ್ನು ಒತ್ತಿ, ನಕ್ಷೆಯ ಬೇಕಾದ ಭಾಗದ ಮೇಲೆ ಪೆಟ್ಟಿಗೆಯನ್ನು ಹೊಂದಿಸಿ, ರೆಕಾರ್ಡ್ ಮಾಡಲು ಮತ್ತೆ ಒತ್ತಿ. ಅನಿಮೇಷನ್‌ನ ಒಂದು ಪೂರ್ಣ ಚಕ್ರ ರೆಕಾರ್ಡ್ ಆಗುತ್ತದೆ, ಆದ್ದರಿಂದ ವೀಡಿಯೊ ಅಡೆತಡೆಯಿಲ್ಲದೆ ಮರುಕಳಿಸುತ್ತದೆ; {max} ಸೆಕೆಂಡುಗಳಿಗಿಂತ (Strava ಸ್ವೀಕರಿಸುವ ಅತಿ ಉದ್ದದ ವೀಡಿಯೊ) ಉದ್ದದ ಚಕ್ರವನ್ನು {max} ನಲ್ಲಿ ಕತ್ತರಿಸಲಾಗುತ್ತದೆ.",
  "tab.info.contributeHeading": "ಕೊಡುಗೆ ನೀಡಿ",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> GitHub ನಲ್ಲಿ ಪ್ರಾಯೋಜಿಸಿ",
  "tab.info.contactsHeading": "ಸಂಪರ್ಕಗಳು",
  "map.basemapAndTerrain": "ಬೇಸ್‌ಮ್ಯಾಪ್ ಮತ್ತು ಭೂಪ್ರದೇಶ",
  "map.pauseAnimation": "ಅನಿಮೇಷನ್ ನಿಲ್ಲಿಸಿ",
  "map.resumeAnimation": "ಅನಿಮೇಷನ್ ಮುಂದುವರಿಸಿ",
  "capture.record": "ವೀಡಿಯೊ ರೆಕಾರ್ಡ್ ({period} ಸೆ. ಚಕ್ರ)",
  "capture.recordTruncated": "ವೀಡಿಯೊ ರೆಕಾರ್ಡ್ (ಒಂದು ಚಕ್ರ {period} ಸೆ.; ಮೊದಲ {max} ಸೆ. ಮಾತ್ರ ರೆಕಾರ್ಡ್ ಆಗುತ್ತದೆ)",
  "capture.recordArea": "ಪೆಟ್ಟಿಗೆಯೊಳಗಿನ ಪ್ರದೇಶವನ್ನು ರೆಕಾರ್ಡ್ ಮಾಡಿ",
  "capture.stop": "ರೆಕಾರ್ಡಿಂಗ್ ನಿಲ್ಲಿಸಿ",
  "capture.selectionTooSmall": "ಆಯ್ಕೆ ತುಂಬಾ ಚಿಕ್ಕದಾಗಿದೆ",
  "capture.saved": "{name} ಉಳಿಸಲಾಗಿದೆ ({size})",
  "capture.cancelled": "ರೆಕಾರ್ಡಿಂಗ್ ರದ್ದಾಗಿದೆ",
  "capture.failed": "ರೆಕಾರ್ಡಿಂಗ್ ವಿಫಲವಾಗಿದೆ: {error}",
  "capture.loadingEncoder": "ಎನ್‌ಕೋಡರ್ ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
  "capture.waitingForMap": "ನಕ್ಷೆ ಲೋಡ್ ಆಗಲು ಕಾಯುತ್ತಿದೆ…",
  "capture.encoding": "ಎನ್‌ಕೋಡ್ ಆಗುತ್ತಿದೆ… {percent}%",
  "capture.finalizing": "ಪೂರ್ಣಗೊಳಿಸುತ್ತಿದೆ…",
  "share.title": "ಈ ನಕ್ಷೆಯ ಲಿಂಕ್ ಹಂಚಿಕೊಳ್ಳಿ",
  "share.copied": "ಲಿಂಕ್ ನಕಲಿಸಲಾಗಿದೆ",
  "share.copiedUnshared": "ಲಿಂಕ್ ನಕಲಿಸಲಾಗಿದೆ — ಆದರೆ ನಿಮ್ಮ ನಕ್ಷೆ ಹಂಚಿಕೊಂಡಿಲ್ಲ, ಆದ್ದರಿಂದ ಬೇರೆ ಯಾರೂ ಅದನ್ನು ತೆರೆಯಲಾರರು. ಬದಲಿಸಲು “ಹಂಚಿದ ನಕ್ಷೆಗಳು” ಆನ್ ಮಾಡಿ.",
  "share.unshared": "ನಿಮ್ಮ ನಕ್ಷೆ ಹಂಚಿಕೊಂಡಿಲ್ಲ, ಆದ್ದರಿಂದ ಬೇರೆ ಯಾರೂ ಈ ಲಿಂಕ್ ತೆರೆಯಲಾರರು. ಬದಲಿಸಲು “ಹಂಚಿದ ನಕ್ಷೆಗಳು” ಆನ್ ಮಾಡಿ.",
  "share.copyThis": "ಈ ಲಿಂಕ್ ನಕಲಿಸಿ:",
  "update.available": "Heatflask ನ ಹೊಸ ಆವೃತ್ತಿ ಲಭ್ಯವಿದೆ.",
  "update.reload": "ಮರುಲೋಡ್ ಮಾಡಿ",
  "import.title": "ಆಮದು ಆಗುತ್ತಿದೆ",
  "import.stop": "ನಿಲ್ಲಿಸಿ",
  "import.stopping": "ನಿಲ್ಲುತ್ತಿದೆ…",
  "import.contacting": "Strava ಸಂಪರ್ಕಿಸುತ್ತಿದೆ…",
  "import.countOf": "ಚಟುವಟಿಕೆಗಳು: {total} ರಲ್ಲಿ {received}",
  "import.count": "ಚಟುವಟಿಕೆಗಳು: {received}",
  "import.waitStrava": "Strava ಡೌನ್‌ಲೋಡ್ ಮಿತಿಯಿಂದ {time} ವರೆಗೆ ನಿಂತಿದೆ. ಈ ಪುಟವನ್ನು ತೆರೆದೇ ಇಡಿ; ಮರುಲೋಡ್ ಮಾಡಿದರೆ ವೇಗ ಹೆಚ್ಚುವುದಿಲ್ಲ.",
  "import.waitRationed": "ಇಂದಿನ ವೇಗದ ಡೌನ್‌ಲೋಡ್‌ಗಳು ಮುಗಿದಿವೆ. ಉಳಿದವು {time}ಕ್ಕೆ ನಿಧಾನವಾಗಿ ಮುಂದುವರಿಯುತ್ತವೆ. ಈ ಪುಟವನ್ನು ತೆರೆದೇ ಇಡಿ.",
  "import.dailyLimit": "Strava ದೈನಂದಿನ ಡೌನ್‌ಲೋಡ್ ಮಿತಿ ಮುಗಿದಿದೆ. {time} ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "import.dailyRationed": "ಇಂದಿನ ನಿಮ್ಮ Strava ಡೌನ್‌ಲೋಡ್ ಪಾಲು ಮುಗಿದಿದೆ. {time} ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  "import.noActivitiesYet": "ನಿಮ್ಮ Strava ಖಾತೆಯಲ್ಲಿ ಇನ್ನೂ ಯಾವುದೇ ಚಟುವಟಿಕೆಗಳಿಲ್ಲ. Strava ನಲ್ಲಿ ಒಂದನ್ನು ರೆಕಾರ್ಡ್ ಮಾಡಿ ಅಥವಾ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ, ಅದು ಇಲ್ಲಿ ಕಾಣಿಸುತ್ತದೆ.",
  "table.noActivities": "ಯಾವುದೇ ಚಟುವಟಿಕೆಗಳಿಲ್ಲ",
  "table.untitled": "(ಶೀರ್ಷಿಕೆ ಇಲ್ಲ)",
  "activities.pageTitle": "{app} — ಚಟುವಟಿಕೆ ಸೂಚಿ",
  "activities.heading": "ಚಟುವಟಿಕೆ ಸೂಚಿ",
  "activities.fetching": "ಚಟುವಟಿಕೆಗಳನ್ನು ತರುತ್ತಿದೆ...",
  "activities.rateLimit": "Strava ವಿನಂತಿ ಮಿತಿ ತಲುಪಿದೆ; {time} ಕ್ಕೆ ಮುಂದುವರಿಯುತ್ತದೆ",
  "activities.noData": "ಕ್ಷಮಿಸಿ, ಡೇಟಾ ಇಲ್ಲ &#128577;",
  "activities.colServerCache": "ಟ್ರ್ಯಾಕ್ ಸರ್ವರ್‌ನಲ್ಲಿ ಉಳಿಸಲಾಗಿದೆ (Mongo)",
  "activities.colBrowserCache": "ಟ್ರ್ಯಾಕ್ ಈ ಬ್ರೌಸರ್‌ನಲ್ಲಿ ಉಳಿಸಲಾಗಿದೆ",
  "activities.cachedServer": "{id} ಟ್ರ್ಯಾಕ್ ಸರ್ವರ್‌ನಲ್ಲಿ ಉಳಿಸಲಾಗಿದೆ",
  "activities.notCachedServer": "{id} ಟ್ರ್ಯಾಕ್ ಸರ್ವರ್‌ನಲ್ಲಿ ಉಳಿಸಲಾಗಿಲ್ಲ",
  "activities.cachedBrowser": "{id} ಟ್ರ್ಯಾಕ್ ಈ ಬ್ರೌಸರ್‌ನಲ್ಲಿ ಉಳಿಸಲಾಗಿದೆ",
  "activities.notCachedBrowser": "{id} ಟ್ರ್ಯಾಕ್ ಈ ಬ್ರೌಸರ್‌ನಲ್ಲಿ ಉಳಿಸಲಾಗಿಲ್ಲ",
  "sport.AlpineSki": "ಆಲ್ಪೈನ್ ಸ್ಕೀಯಿಂಗ್",
  "sport.BackcountrySki": "ಬ್ಯಾಕ್‌ಕಂಟ್ರಿ ಸ್ಕೀಯಿಂಗ್",
  "sport.Badminton": "ಬ್ಯಾಡ್ಮಿಂಟನ್",
  "sport.Basketball": "ಬಾಸ್ಕೆಟ್‌ಬಾಲ್",
  "sport.Canoeing": "ಕನೂಯಿಂಗ್",
  "sport.Cricket": "ಕ್ರಿಕೆಟ್",
  "sport.Crossfit": "ಕ್ರಾಸ್‌ಫಿಟ್",
  "sport.Dance": "ನೃತ್ಯ",
  "sport.EBikeRide": "ಇ-ಬೈಕ್ ಸವಾರಿ",
  "sport.Elliptical": "ಎಲಿಪ್ಟಿಕಲ್",
  "sport.EMountainBikeRide": "ಇ-ಮೌಂಟನ್ ಬೈಕ್ ಸವಾರಿ",
  "sport.Golf": "ಗಾಲ್ಫ್",
  "sport.GravelRide": "ಗ್ರಾವೆಲ್ ಸವಾರಿ",
  "sport.Handcycle": "ಹ್ಯಾಂಡ್‌ಸೈಕಲ್",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "ಚಾರಣ",
  "sport.IceSkate": "ಐಸ್ ಸ್ಕೇಟಿಂಗ್",
  "sport.InlineSkate": "ಇನ್‌ಲೈನ್ ಸ್ಕೇಟಿಂಗ್",
  "sport.Kayaking": "ಕಯಾಕಿಂಗ್",
  "sport.Kitesurf": "ಕೈಟ್‌ಸರ್ಫಿಂಗ್",
  "sport.MountainBikeRide": "ಮೌಂಟನ್ ಬೈಕ್ ಸವಾರಿ",
  "sport.NordicSki": "ನಾರ್ಡಿಕ್ ಸ್ಕೀಯಿಂಗ್",
  "sport.Padel": "ಪ್ಯಾಡೆಲ್",
  "sport.PhysicalTherapy": "ಫಿಸಿಯೋಥೆರಪಿ",
  "sport.Pickleball": "ಪಿಕಲ್‌ಬಾಲ್",
  "sport.Pilates": "ಪಿಲಾಟೆಸ್",
  "sport.Racquetball": "ರ‍್ಯಾಕೆಟ್‌ಬಾಲ್",
  "sport.Ride": "ಸೈಕಲ್ ಸವಾರಿ",
  "sport.RockClimbing": "ಬಂಡೆ ಹತ್ತುವುದು",
  "sport.RollerSki": "ರೋಲರ್ ಸ್ಕೀ",
  "sport.Rowing": "ದೋಣಿ ಹುಟ್ಟು ಹಾಕುವುದು",
  "sport.Run": "ಓಟ",
  "sport.Sail": "ಹಾಯಿದೋಣಿ",
  "sport.Skateboard": "ಸ್ಕೇಟ್‌ಬೋರ್ಡ್",
  "sport.Snowboard": "ಸ್ನೋಬೋರ್ಡ್",
  "sport.Snowshoe": "ಸ್ನೋಶೂ",
  "sport.Soccer": "ಫುಟ್‌ಬಾಲ್",
  "sport.Squash": "ಸ್ಕ್ವಾಷ್",
  "sport.StairStepper": "ಸ್ಟೇರ್ ಸ್ಟೆಪ್ಪರ್",
  "sport.StandUpPaddling": "ಸ್ಟ್ಯಾಂಡ್ ಅಪ್ ಪ್ಯಾಡ್ಲಿಂಗ್",
  "sport.Surfing": "ಸರ್ಫಿಂಗ್",
  "sport.Swim": "ಈಜು",
  "sport.TableTennis": "ಟೇಬಲ್ ಟೆನಿಸ್",
  "sport.Tennis": "ಟೆನಿಸ್",
  "sport.TrailRun": "ಟ್ರೈಲ್ ಓಟ",
  "sport.Velomobile": "ವೆಲೋಮೊಬೈಲ್",
  "sport.VirtualRide": "ವರ್ಚುವಲ್ ಸವಾರಿ",
  "sport.VirtualRow": "ವರ್ಚುವಲ್ ದೋಣಿ",
  "sport.VirtualRun": "ವರ್ಚುವಲ್ ಓಟ",
  "sport.Volleyball": "ವಾಲಿಬಾಲ್",
  "sport.Walk": "ನಡಿಗೆ",
  "sport.WeightTraining": "ತೂಕ ತರಬೇತಿ",
  "sport.Wheelchair": "ಗಾಲಿಕುರ್ಚಿ",
  "sport.Windsurf": "ವಿಂಡ್‌ಸರ್ಫಿಂಗ್",
  "sport.Workout": "ವ್ಯಾಯಾಮ",
  "sport.Yoga": "ಯೋಗ"
}
